/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { next } from '@ember/runloop';

export default class TriangulationRoute extends Route {
  // Services
  @service
  store;

  model() {
    let group = this.modelFor('group');

    return hash({
      group,
      subjects: this.store.query('goals/subject', { trackable: true }),
      milestones: this.store.query('milestones/milestone', {
        progressionType: ProgressionType.PROGRESSION,
      }),
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    model.subjects = model.subjects
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('group/triangulation').set('selectedMilestoneSet', null);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }
}
